import { faBolt, faCircleExclamation, faCircleInfo, faCircleQuestion, faFlask, faRocketLaunch, faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Action from '../../Action';

import * as style from './style.module.css';

const Container = ({ type, children, action, ...props }) => action ? <Action {...props} action={action}>{children}</Action> : (type === 'CODE' ? <code {...props}>{children}</code> : <div {...props}>{children}</div>);

const Alert = ({ type = "INFORMATION", className = '', icon = null, transparent = false, action = null, disableMargin = false, children, ...props }) => {
  const containerProps = { ...props, action, className: `${style.alert} ${transparent ? style.transparent : ''} ${action ? style.hoverable : ''} ${style[(type || 'INFORMATION').toLowerCase()] || 'block'} ${disableMargin ? style.disableMargin : ''} ${className}` };

  const icons = {
    WARNING: faTriangleExclamation,
    ERROR: faCircleExclamation,
    INFORMATION: faCircleInfo,
    QUESTION: faCircleQuestion,
    BOOST: faBolt,
    EXPERIMENTAL: faFlask,
    PREMIUM: faRocketLaunch,
  };

  return (
    <Container {...containerProps}>
      {(icons[type] || icon) && <FontAwesomeIcon icon={icon || icons[type]} />}
      {children}
    </Container>
  );
};

export default Alert;
